import { EXPERTISES } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import {
  ExpertReportExpertise,
  IExpertGlobalReportState,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import { get, isEmpty, isNil } from 'lodash';
import { VictimType } from 'containers/ExpertExpertise/Victim/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import {
  STATUS_CONTESTED,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';

export const shouldRenderExpertiseByType = (expertiseId: string) => {
  //convert to string for comparaison
  const id = String(expertiseId);

  const shouldRenderVictimFields =
    id === EXPERTISES.ACCOUNTING || id === EXPERTISES.MEDICAL;

  const shouldRenderVehiculeFields =
    id === EXPERTISES.MECHANICAL || id === EXPERTISES.ACCOUNTING;

  return { shouldRenderVictimFields, shouldRenderVehiculeFields };
};

export const getDocumentId = (id: string, addExpertiseId: string) =>
  `${id}${addExpertiseId}`;

export const filterEmptyJudgements = (
  expertReport: IExpertGlobalReportState[],
) => {
  return expertReport.filter((el: IExpertGlobalReportState) => {
    let isRecentVictims: VictimType[] = [];
    let isRecentVehicles: Vehicule[] = [];
    el.expertises.forEach((exp: ExpertReportExpertise) => {
      isRecentVictims = exp.victims.filter((el: any) => !el.isOld);
      isRecentVehicles = exp.vehicules.filter((el: any) => !el.isOld);
    });
    return !(isEmpty(isRecentVictims) && isEmpty(isRecentVehicles));
  });
};
export const resolveSagisInfo = (
  toUpdate: boolean,
  isManager: boolean = false,
  currentExpertise: any,
) => {
  return (
    (!toUpdate && isManager && !isNil(get(currentExpertise, 'victimId'))) ||
    ((get(currentExpertise, 'status') === STATUS_VALIDATED ||
      get(currentExpertise, 'status') === STATUS_CONTESTED) &&
      toUpdate &&
      isManager &&
      !isNil(get(currentExpertise, 'victimId')))
  );
};
export const getResponsibilityShareByExpertise = (
  expertiseJudgementAddDocumentId: any,
  judgementAddDocuments: any[],
) => {
  const judgementAddDocument =
    (judgementAddDocuments &&
      judgementAddDocuments.find((item: JudgementADDDocumentType) => {
        const jadd =
          get(item, 'expertises', []).find(expertise => {
            return (
              expertise.expertiseJudgementAddDocumentId ===
              expertiseJudgementAddDocumentId
            );
          }) || {};
        return isEmpty(jadd) ? null : jadd;
      })) ||
    {};

  return (
    get(judgementAddDocument, 'responsibilityShare', '') === 0 ||
    get(judgementAddDocument, 'responsibilityShare', '') === null
  );
};
export const renderExpertiseData = (
  victimExpertises: any,
  vehicleExpertises: any,
  item: any,
) => {
  if (!isEmpty(get(item, 'victimExpertise')) && !isEmpty(victimExpertises)) {
    return victimExpertises?.find(
      (el: any) => el.id === get(item, 'victimExpertise.id'),
    );
  } else if (
    !isEmpty(get(item, 'vehiculeExpertise')) &&
    !isEmpty(vehicleExpertises)
  ) {
    return vehicleExpertises?.find(
      (el: any) => el.id === get(item, 'vehiculeExpertise.id'),
    );
  } else {
    return {};
  }
};
